var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _rect, _rect2, _rect3, _path5, _path6, _circle5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTableDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2028,
    height: 1261,
    viewBox: "0 0 2028 1261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 972,
    cy: 620,
    r: 404,
    fill: "url(#paint0_linear_652_8509)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "matrix(1 0 0 -1 1234 88)",
    fill: "url(#paint1_linear_652_8509)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "matrix(1 0 0 -1 175 238)",
    fill: "#CDCDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1469.07 631.9C1473.45 630.54 1478.16 630.726 1482.42 632.427C1486.68 634.128 1490.22 637.241 1492.46 641.245C1494.7 645.248 1495.49 649.899 1494.71 654.417C1493.92 658.936 1491.61 663.048 1488.16 666.064C1484.7 669.081 1480.32 670.819 1475.73 670.987C1471.15 671.155 1466.65 669.743 1462.98 666.987C1459.32 664.232 1456.71 660.3 1455.6 655.851C1454.48 651.402 1454.94 646.706 1456.87 642.549L1462.7 645.267C1461.39 648.087 1461.08 651.273 1461.84 654.291C1462.59 657.309 1464.36 659.976 1466.85 661.845C1469.33 663.714 1472.39 664.672 1475.5 664.558C1478.61 664.444 1481.58 663.265 1483.92 661.219C1486.27 659.173 1487.84 656.383 1488.37 653.318C1488.9 650.253 1488.36 647.098 1486.84 644.382C1485.33 641.667 1482.92 639.555 1480.03 638.401C1477.14 637.247 1473.95 637.121 1470.98 638.044L1469.07 631.9Z",
    fill: "url(#paint2_linear_652_8509)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M878 1237.5C878 1224.52 867.479 1214 854.5 1214C841.521 1214 831 1224.52 831 1237.5C831 1250.48 841.521 1261 854.5 1261C867.479 1261 878 1250.48 878 1237.5ZM847.18 1237.5C847.18 1233.46 850.457 1230.18 854.5 1230.18C858.543 1230.18 861.82 1233.46 861.82 1237.5C861.82 1241.54 858.543 1244.82 854.5 1244.82C850.457 1244.82 847.18 1241.54 847.18 1237.5Z",
    fill: "#CDCDCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M508 1120.5C508 1110.84 500.165 1103 490.5 1103C480.835 1103 473 1110.84 473 1120.5C473 1130.16 480.835 1138 490.5 1138C500.165 1138 508 1130.16 508 1120.5ZM483.226 1120.5C483.226 1116.48 486.483 1113.23 490.5 1113.23C494.517 1113.23 497.774 1116.48 497.774 1120.5C497.774 1124.52 494.517 1127.77 490.5 1127.77C486.483 1127.77 483.226 1124.52 483.226 1120.5Z",
    fill: "url(#paint3_linear_652_8509)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M471 130C471 118.954 462.046 110 451 110C439.954 110 431 118.954 431 130C431 141.046 439.954 150 451 150C462.046 150 471 141.046 471 130ZM440.926 130C440.926 124.436 445.436 119.926 451 119.926C456.564 119.926 461.074 124.436 461.074 130C461.074 135.564 456.564 140.074 451 140.074C445.436 140.074 440.926 135.564 440.926 130Z",
    fill: "url(#paint4_linear_652_8509)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "matrix(1 0 0 -1 1734 130)",
    fill: "#CDCDCD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 296,
    width: 974,
    height: 183,
    rx: 47,
    fill: "white",
    stroke: "#CECECE",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 528,
    width: 974,
    height: 183,
    rx: 47,
    fill: "white",
    stroke: "#CECECE",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 760,
    width: 974,
    height: 183,
    rx: 47,
    fill: "white",
    stroke: "#CECECE",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M743 390C743 360.729 719.271 337 690 337C660.729 337 637 360.729 637 390C637 419.271 660.729 443 690 443C719.271 443 743 419.271 743 390ZM643.029 390C643.029 364.059 664.059 343.029 690 343.029C715.941 343.029 736.971 364.059 736.971 390C736.971 415.941 715.941 436.971 690 436.971C664.059 436.971 643.029 415.941 643.029 390Z",
    fill: "#CDCDCD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M743 852C743 822.729 719.271 799 690 799C660.729 799 637 822.729 637 852C637 881.271 660.729 905 690 905C719.271 905 743 881.271 743 852ZM643.029 852C643.029 826.059 664.059 805.029 690 805.029C715.941 805.029 736.971 826.059 736.971 852C736.971 877.941 715.941 898.971 690 898.971C664.059 898.971 643.029 877.941 643.029 852Z",
    fill: "#CDCDCD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    transform: "matrix(1 0 0 -1 424 676)",
    fill: "url(#paint5_linear_652_8509)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M502.132 608.989L470.757 640.141C470.483 640.413 470.159 640.629 469.801 640.777C469.444 640.924 469.06 641 468.673 641C468.286 641 467.903 640.924 467.545 640.777C467.188 640.629 466.863 640.413 466.59 640.141L452.863 626.512C452.589 626.241 452.372 625.918 452.224 625.563C452.076 625.208 452 624.828 452 624.443C452 624.059 452.076 623.679 452.224 623.324C452.372 622.969 452.589 622.646 452.863 622.375C453.137 622.103 453.461 621.888 453.819 621.741C454.176 621.594 454.56 621.518 454.947 621.518C455.333 621.518 455.717 621.594 456.074 621.741C456.432 621.888 456.756 622.103 457.03 622.375L468.676 633.937L497.97 604.857C498.523 604.308 499.272 604 500.053 604C500.835 604 501.584 604.308 502.137 604.857C502.69 605.406 503 606.15 503 606.926C503 607.701 502.69 608.446 502.137 608.994L502.132 608.989Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.434 610.876C60.1653 611.322 59.8108 611.712 59.3909 612.022C58.9711 612.331 58.4939 612.556 57.9868 612.682C57.4797 612.808 56.9526 612.834 56.4356 612.757C55.9185 612.681 55.4217 612.504 54.9736 612.236L34.4781 599.993V622.04C34.4781 623.09 34.059 624.097 33.3129 624.84C32.5668 625.583 31.5549 626 30.4997 626C29.4446 626 28.4327 625.583 27.6866 624.84C26.9405 624.097 26.5213 623.09 26.5213 622.04V599.993L6.02585 612.236C5.57785 612.503 5.08128 612.68 4.5645 612.757C4.04771 612.834 3.52084 612.808 3.01395 612.682C2.50706 612.556 2.03009 612.332 1.61026 612.022C1.19044 611.713 0.835984 611.324 0.567139 610.878C0.0241812 609.977 -0.137114 608.899 0.118735 607.88C0.374584 606.861 1.02662 605.985 1.9314 605.444L22.7683 593L1.9314 580.556C1.02662 580.015 0.374584 579.139 0.118735 578.12C-0.137114 577.101 0.0241812 576.023 0.567139 575.122C1.1101 574.222 1.99024 573.573 3.01395 573.318C4.03765 573.063 5.12107 573.224 6.02585 573.764L26.5213 586.007V563.96C26.5213 562.91 26.9405 561.903 27.6866 561.16C28.4327 560.417 29.4446 560 30.4997 560C31.5549 560 32.5668 560.417 33.3129 561.16C34.059 561.903 34.4781 562.91 34.4781 563.96V586.007L54.9736 573.764C55.4216 573.497 55.9182 573.32 56.4349 573.243C56.9517 573.166 57.4786 573.192 57.9855 573.318C58.4924 573.444 58.9694 573.668 59.3892 573.978C59.809 574.287 60.1635 574.676 60.4323 575.122C60.7011 575.568 60.8791 576.062 60.9561 576.577C61.033 577.091 61.0074 577.616 60.8807 578.12C60.754 578.625 60.5287 579.1 60.2177 579.517C59.9067 579.935 59.516 580.288 59.068 580.556L38.2311 593L59.068 605.444C59.9727 605.984 60.6248 606.86 60.8809 607.879C61.1371 608.897 60.9763 609.975 60.434 610.876Z",
    fill: "#CDCDCD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 354.5C228 352.567 226.433 351 224.5 351C222.567 351 221 352.567 221 354.5V372.5C221 374.433 222.567 376 224.5 376C226.433 376 228 374.433 228 372.5V354.5ZM228 415.5C228 413.567 226.433 412 224.5 412C222.567 412 221 413.567 221 415.5V433.5C221 435.433 222.567 437 224.5 437C226.433 437 228 435.433 228 433.5V415.5ZM241 395.5C241 393.567 242.567 392 244.5 392H262.5C264.433 392 266 393.567 266 395.5C266 397.433 264.433 399 262.5 399H244.5C242.567 399 241 397.433 241 395.5ZM183.5 392C181.567 392 180 393.567 180 395.5C180 397.433 181.567 399 183.5 399H201.5C203.433 399 205 397.433 205 395.5C205 393.567 203.433 392 201.5 392H183.5Z",
    fill: "#CDCDCD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.884 3.5C726.884 1.567 725.317 0 723.384 0C721.451 0 719.884 1.567 719.884 3.5V10.4535C719.884 12.3865 721.451 13.9535 723.384 13.9535C725.317 13.9535 726.884 12.3865 726.884 10.4535V3.5ZM726.884 37.5465C726.884 35.6135 725.317 34.0465 723.384 34.0465C721.451 34.0465 719.884 35.6135 719.884 37.5465V44.5C719.884 46.433 721.451 48 723.384 48C725.317 48 726.884 46.433 726.884 44.5V37.5465ZM731.047 23.2907C731.047 21.3577 732.614 19.7907 734.547 19.7907H741.5C743.433 19.7907 745 21.3577 745 23.2907C745 25.2237 743.433 26.7907 741.5 26.7907H734.547C732.614 26.7907 731.047 25.2237 731.047 23.2907ZM700.5 19.7907C698.567 19.7907 697 21.3577 697 23.2907C697 25.2237 698.567 26.7907 700.5 26.7907H707.453C709.386 26.7907 710.953 25.2237 710.953 23.2907C710.953 21.3577 709.386 19.7907 707.453 19.7907H700.5Z",
    fill: "#CDCDCD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1816 451.5C1822.48 457.48 1836 462 1836 462C1836 462 1823.05 468.951 1816.5 475.5C1809.95 482.049 1803 495 1803 495C1803 495 1796.82 481.974 1790.5 475.5C1783.81 468.639 1770 462 1770 462C1770 462 1783.91 456.89 1790.5 450.5C1797.47 443.739 1803 429 1803 429C1803 429 1808.54 444.62 1816 451.5Z",
    fill: "url(#paint6_linear_652_8509)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2016.18 802.295C2020.01 805.829 2028 808.5 2028 808.5C2028 808.5 2020.35 812.607 2016.48 816.477C2012.61 820.347 2008.5 828 2008.5 828C2008.5 828 2004.85 820.303 2001.11 816.477C1997.16 812.423 1989 808.5 1989 808.5C1989 808.5 1997.22 805.481 2001.11 801.705C2005.23 797.709 2008.5 789 2008.5 789C2008.5 789 2011.77 798.23 2016.18 802.295Z",
    fill: "url(#paint7_linear_652_8509)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M809 388L1412 388",
    stroke: "#DCDCDC",
    strokeWidth: 27,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M603 620L1206 620",
    stroke: "#DCDCDC",
    strokeWidth: 27,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M801 852L1404 852",
    stroke: "#DCDCDC",
    strokeWidth: 27,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_8509",
    x1: 607.831,
    y1: 105.042,
    x2: 2609.21,
    y2: 765.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_652_8509",
    x1: 1.97183,
    y1: -5.49296,
    x2: 101.05,
    y2: 27.1837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_652_8509",
    x1: 1456.97,
    y1: 676.493,
    x2: 1556.05,
    y2: 643.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_652_8509",
    x1: 474.725,
    y1: 1142.81,
    x2: 561.419,
    y2: 1114.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_652_8509",
    x1: 432.972,
    y1: 155.493,
    x2: 532.05,
    y2: 122.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_652_8509",
    x1: 5.22535,
    y1: -14.5563,
    x2: 267.782,
    y2: 72.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_652_8509",
    x1: 1773.25,
    y1: 419.937,
    x2: 1936.73,
    y2: 473.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_652_8509",
    x1: 1990.92,
    y1: 783.644,
    x2: 2087.52,
    y2: 815.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A935FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableDark);
export default __webpack_public_path__ + "static/media/emptyTableDark.e8a6e479c0c7c2330004a269e268ec3b.svg";
export { ForwardRef as ReactComponent };